import { Injectable } from "@angular/core";
import { Response, Headers, RequestOptions } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { Constants } from "../constants/constants";
import { HttpClient } from "../authentication/httpClient";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import "rxjs/add/observable/throw";

@Injectable()
export class airQuoteFormService {

    constructor(private http: HttpClient) { }

    getQuoteForm(): Observable<IAirQuoteFormModel> {   
       
        return this.http.get(`${Constants.restUrl}AirQuoteForm/GetQuoteForm`, {}).map((res: Response) => res.json()).catch(this.handleError);
    }

    addPurchaseForm(approval: IAirQuoteModel): Observable<IAirQuoteModel> {
       
        return this.http.post(`${Constants.restUrl}AirQuoteForm/AddQuoteForm`, approval).map((res: Response) => res.json());
    }

    savePurchaseForm(approval: IAirQuoteModel): Observable<IAirQuoteModel> {
        return this.http.post(`${Constants.restUrl}AirQuoteForm/SaveQuoteForm`, approval).map((res: Response) => res.json());
    }

    updateQuote(approval: IAirQuoteModel): Observable<IAirQuoteModel> {
        return this.http.put(`${Constants.restUrl}AirQuoteForm/UpdateQuoteForm`, approval).map((res: Response) => res.json());
    }

    removeAttachment(attachment: IAttachmentModal): Observable<boolean> {
        return this.http.delete(`${Constants.restUrl}PurchaseForm/RemoveAttachment/${attachment.id}`, {}).map((res: Response) => res.json());
    }

    //getQuoteApprovers(managerEmail: string): Observable<Array<IAirQuoteFormManagerModel>> {
    //    return this.http.get(`${Constants.restUrl}AirFreightPurchaseForm/GetQuoteApprovers/${managerEmail}`, {}).map((res: Response) => res.json()).catch(this.handleError);
    //}

    //getApproverById(approverId: number): Observable<IAirFreightQuoteApproverModel> {
    //    return this.http.get(`${Constants.restUrl}AirFreightApprovers/get/${approverId}`, {}).map((res: Response) => res.json()).catch(this.handleError);
    //}

    updateQuoteStatus(approvalId: number, toFormStatusId: number, username: string): Observable<boolean> {
        return this.http.put(`${Constants.restUrl}AirQuoteForm/UpdateQuoteStatus/${approvalId}/${toFormStatusId}/${username}`, {}).map((res: Response) => res.json()).catch(this.handleError);
    }

    uploadAttachments(attachments: Array<File>, formId: number, formTypeId: number) {
        let formData = new FormData();

        for (let i = 0; i < attachments.length; i++)
            formData.append(attachments[i].name, attachments[i]);

        formData.append("formId", ""+formId);
        formData.append("formTypeId", ""+formTypeId);

        let headers = new Headers();
        headers.append("Accept", "application/json");

        let options = new RequestOptions({ headers: headers });
        
        return this.http.post(`${Constants.restUrl}PurchaseForm/UploadAttachments`, formData, options).map((res: Response) => res.json());
    }

    private handleError(error: any): Observable<any> {
        console.error("An error occurred", error);
        return Observable.throw(error.message || error);
    }
}